import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/date-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-a7ac6248"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "searchMain bg-fff m-t-8" }
const _hoisted_2 = { class: "d-f" }
const _hoisted_3 = {
  key: 0,
  class: "d-f flex-d-c flex-w-auto m-l-16"
}
const _hoisted_4 = { class: "label-text-12" }
const _hoisted_5 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_6 = { class: "label-text-12" }
const _hoisted_7 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_8 = { class: "label-text-12" }
const _hoisted_9 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_10 = { class: "label-text-12" }
const _hoisted_11 = {
  class: "flex-w-auto",
  style: {"padding-top":"25px","flex":"1.5"}
}
const _hoisted_12 = { class: "f-r" }
const _hoisted_13 = { class: "d-f m-t-16" }
const _hoisted_14 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_15 = { class: "label-text-12" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-w-auto m-l-16 hide" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-w-auto m-l-16 hide" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-w-auto m-l-16 hide" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-w-auto m-l-16 hide" }, null, -1))
const _hoisted_21 = { class: "d-f search-btns" }
const _hoisted_22 = { class: "table-main bg-fff m-t-8 flex-w-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_main_wrapper = _resolveComponent("main-wrapper")!

  return (_openBlock(), _createBlock(_component_main_wrapper, { className: "p-l-r-10" }, {
    header: _withCtx(() => [
      _createVNode(_component_Breadcrumb, { dataSource: [] })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (
            _ctx.$store.state.user.legalEntity.entityCode === 'Dealer' ||
            _ctx.$store.state.user.legalEntity.entityCode === 'Dealer Group'
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("salesmeasure.bu")), 1),
                _createVNode(_component_a_select, {
                  value: _ctx.bu,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bu) = $event)),
                  mode: "multiple"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: item.id,
                        key: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$i18n.locale === "zh" ? item.nameCn : item.nameEn), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("salesmeasure.batchname")), 1),
            _createVNode(_component_a_input, {
              value: _ctx.batchName,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batchName) = $event)),
              maxlength: 50
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("salesmeasure.programname")), 1),
            _createVNode(_component_a_input, {
              value: _ctx.programName,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.programName) = $event)),
              maxlength: 50
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("salesmeasure.programcode")), 1),
            _createVNode(_component_a_input, {
              value: _ctx.programCode,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.programCode) = $event)),
              maxlength: 50
            }, null, 8, ["value"])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_a_button, {
                class: "m-l-16",
                onClick: _ctx.handlerResetClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("salesmeasure.reset")), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                class: "m-l-16",
                type: "primary",
                onClick: _ctx.handlerSearchClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("salesmeasure.search")), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                type: "link",
                onClick: _ctx.handleCollapse,
                style: {"padding-right":"0"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("salesmeasure.expand")), 1),
                  _createElementVNode("i", {
                    class: _normalizeClass(["font_family m-l-5 v-align-1", _ctx.isOpen ? 'icon-xiangshang' : 'icon-xiangxia'])
                  }, null, 2)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ], 512), [
            [_vShow, !_ctx.isOpen]
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("salesmeasure.releaseperiod")), 1),
            _createVNode(_component_a_range_picker, {
              style: { width: 100 + '%' },
              value: [_ctx.releaseBegin, _ctx.releaseEnd],
              format: "YYYY-MM-DD",
              onChange: _ctx.handlerPeriodChange,
              valueFormat: "YYYY-MM-DD",
              placeholder: ['Start Time', 'End Time']
            }, {
              suffixIcon: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }, 8, ["value", "onChange"])
          ]),
          _hoisted_17,
          _hoisted_18,
          _hoisted_19,
          _hoisted_20
        ], 512), [
          [_vShow, _ctx.isOpen]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_21, [
          _createVNode(_component_a_button, {
            class: "m-l-16",
            onClick: _ctx.handlerResetClick
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("salesmeasure.reset")), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            class: "m-l-16",
            type: "primary",
            onClick: _ctx.handlerSearchClick
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("salesmeasure.search")), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            type: "link",
            onClick: _ctx.handleCollapse
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("salesmeasure.collapse")), 1),
              _createElementVNode("i", {
                class: _normalizeClass(["font_family m-l-5 v-align-1", _ctx.isOpen ? 'icon-xiangshang' : 'icon-xiangxia'])
              }, null, 2)
            ]),
            _: 1
          }, 8, ["onClick"])
        ], 512), [
          [_vShow, _ctx.isOpen]
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_a_table, {
          class: "tab-container default-self-table-text m-t-16",
          dataSource: _ctx.data,
          columns: _ctx.columns,
          pagination: false,
          scroll: { y: _ctx.tableHeight, x: 1000 },
          rowClassName: 
          (record, index) => (index % 2 === 1 ? 'table-striped' : null)
        ,
          rowKey: (item, index) => index
        }, {
          batchName: _withCtx(({ record, text }) => [
            _createVNode(_component_router_link, {
              title: text,
              class: "ellipsis show",
              style: {"width":"207px"},
              to: `/measure/detail?releaseBatchId=${record.releaseBatchId}&releaseBatchName=${record.releaseBatchName}&releaseDate=${record.releaseDate}&isUserBu=${record.isUserBu}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(text), 1)
              ]),
              _: 2
            }, 1032, ["title", "to"])
          ]),
          releaseAt: _withCtx(({ text }) => [
            _createTextVNode(_toDisplayString(text ? _ctx.moment(text).format("YYYY-MM-DD HH:mm:ss") : text), 1)
          ]),
          releaseTo: _withCtx(({ text }) => [
            _createTextVNode(_toDisplayString(text), 1)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "scroll", "rowClassName", "rowKey"]),
        _createVNode(_component_Pagination, {
          onChange: _ctx.handlerPaginationChange,
          current: _ctx.pagination.page,
          onShowSizeChange: _ctx.handlerShowSizeChange,
          pageSize: _ctx.pagination.pageSize,
          total: _ctx.pagination.total
        }, null, 8, ["onChange", "current", "onShowSizeChange", "pageSize", "total"])
      ])
    ]),
    _: 1
  }))
}